export { SiteMenu as default } from './SiteMenu';
